<template>
  <div class="container">
    <div class="topSelect bg-fff bold flexCenter font-16" @click="show = true">{{selectedInfo.elementName}}
      <van-icon name="arrow-down" size="20px" class="pl5" />
    </div>
    <div class="chart bg-fff">
      <canvas id="mountNode"></canvas>
    </div>
    <van-popup v-model="show" position="bottom" :close-on-click-overlay="false" :style="{ height: '50%' }">
      <van-picker title="选择内容" show-toolbar :columns="columns" value-key="elementName" :default-index="selectedInfo.defaultIndex" @confirm="onConfirm" @cancel="show = false" />
    </van-popup>
  </div>
</template>
<script>
  import {Toast,Icon,Popup,Picker  } from "vant";
  export default {
  name: 'ResultTrend',
  components: {
    [Icon.name]:Icon,
    [Popup.name]:Popup,
    [Picker.name]:Picker,
  },
  data() {
    return {
      show:false,
      columns: [],
      selectedInfo:{
        elementId:'',
        elementName:'请选择',
        defaultIndex:0
      },
      brokenLineData:[]
    }
  },
  watch: {
    
  },
  created() {
    if(this.$route.query){
      if(this.$route.query.id){
        this.$set(this.selectedInfo,'elementId',this.$route.query.id)
      }; 
      if(this.$route.query.name){
        this.$set(this.selectedInfo,'elementName',this.$route.query.name);
      };
    };
    this.initialize();
    if(this.$route.query.id){
      this.chartElementData();
    };
  },
  methods: {
    /*获取下拉选择的项目名称*/
    initialize(){
       $.ajax({
        url: this.GLOBAL.url + '/wx/chartElementName',
        type: 'get',
        xhrFields: {
          withCredentials: true
        },
        crossDomain: true,
        data: {

        },
        success: (res) => {
          if (res.code == 200) {
            this.columns = res.data.list;
            let currentIndex = this.columns.findIndex(item=>{
              return item.elementName == this.selectedInfo.elementName
            });
            this.$set(this.selectedInfo,'defaultIndex',currentIndex);
          } else {
            Toast(res.msg)
          };
        },
        error: (e) => {
          console.log(e);
        }
      })
     
    },
    onConfirm(value, index) {
      this.$set(this.selectedInfo,'elementId',value.elementId);
      this.$set(this.selectedInfo,'elementName',value.elementName);
      this.$set(this.selectedInfo,'defaultIndex',index);
      this.chartElementData();
      this.show = false;
    },
    chartElementData(){
      $.ajax({
        url: this.GLOBAL.url + '/wx/chartElementData',
        type: 'get',
        xhrFields: {
          withCredentials: true
        },
        crossDomain: true,
        data: {
            elementId:this.selectedInfo.elementId,
            num:5
        },
        success: (res) => {
          if (res.code == 200) {
            let list = res.data.list;
            if(list && list.length > 0){
              list.forEach((item,index,arr)=>{
                item.resultContent = Number(item.resultContent);
                if(item.referenceLower && item.referenceUpper){//存在区间范围
                  if((item.referenceLower <= item.resultContent) && (item.resultContent <= item.referenceUpper)){
                    item.isAbnormal = false;
                  }else{
                    item.isAbnormal = true;
                  };
                }else if(item.referenceLower && !item.referenceUpper){//只存在最小值
                  if(item.resultContent < item.referenceLower){//异常
                    item.isAbnormal = true;
                  }else{
                    item.isAbnormal = false;
                  };
                }else if(item.referenceUpper && !item.referenceLower){//只存在最大值
                  if(item.resultContent > item.referenceUpper){
                    item.isAbnormal = true;
                  }else{
                    item.isAbnormal = false;
                  }
                }else{
                  item.isAbnormal = false;
                };
              })
            }
            this.brokenLineData = list;
            this.$nextTick(()=>{
              this.showChart();
            });
          } else {
            Toast(res.msg)
          };
        },
        error: (e) => {
          console.log(e);
        }
      });
    },
    showChart() {
      var chart = new this.$F2.Chart({
        id: "mountNode",
        pixelRatio: window.devicePixelRatio
      });
      let maxValue = Math.max.apply(Math, this.brokenLineData.map(function(o) {return Number(o.resultContent)}));//数据的最大值
      let referenceUpper;//参考的最大值
      if(this.brokenLineData.length > 0 && this.brokenLineData[0].referenceUpper){
        referenceUpper = this.brokenLineData[0].referenceUpper;
      }else{
        referenceUpper = 0;
      };
      chart.source(this.brokenLineData, {
        resultContent: {
          tickCount: 3,
          min: 0,
          max:maxValue>referenceUpper?(maxValue*1.5):(referenceUpper*1.5)
        },
        examTime: {
          type: "timeCat",
          tickCount: 3,
          mask:'MM-DD'
        }
      });
      //绘制参考范围 与 绘制Y单位
      if(this.brokenLineData.length > 0){
        let min;let max;let unit;
        //最低
        if(this.brokenLineData[0].referenceLower >= 0){
          min = this.brokenLineData[0].referenceLower;
          chart.guide().line({
            start: ['min', min],
            end: ['max', min],
            style: {
              stroke: '#FF4D4F',
              lineDash: [2]
            }
          });
          chart.guide().text({ // 绘制辅助文本
            position: ['max', min],
            content: '最小值： '+min,
            offsetY: 20,
            style: {
              fill: '#FF4D4F',
              textAlign: 'end',
              textBaseline: 'bottom'
            }
          });
        }; 
        //最高
        if(this.brokenLineData[0].referenceUpper){
          max = this.brokenLineData[0].referenceUpper;
          chart.guide().line({
            start: ['min', max],
            end: ['max', max],
            style: {
              stroke: '#FF4D4F',
              lineDash: [2]
            }
          });
          chart.guide().text({ // 绘制辅助文本
            position: ['max', max],
            content: '最大值： '+max,
            offsetY: -5,
            style: {
              fill: '#FF4D4F',
              textAlign: 'end',
              textBaseline: 'bottom'
            }
          });
        };
        if(this.brokenLineData[0].unit){
          unit = this.brokenLineData[0].unit;
          chart.guide().text({
              position: ['min', 'max'],
              content: unit,
              style: {
                textBaseline: 'middle',
                textAlign: 'start'
              },
              offsetY: -15,
              offsetX: -25
          });
        }
      };
      chart.tooltip({
        showItemMarker: false,
        onShow: function onShow(ev) {
          var items = ev.items;
          items[0].name = null;
          items[0].value = items[0].origin.resultContent;
        }
      });
      chart.axis('examTime', {
        label: {
          rotate: Math.PI / 3,
          textAlign: 'start',
          textBaseline: 'middle'
        }
      });
      chart.interval().position('examTime*resultContent').size(30).color('isAbnormal', isAbnormal => {
        if (isAbnormal) {//异常
          return '#FF4D4F';
        }
        return '#1890ff';
      });
      chart.render();
    }
  },
  computed: {

  },
  mounted(){
    // var self = this;
    // this.$nextTick(()=>{
    //   self.showChart();
    // });
  },
}
</script>
<style type="text/css" scoped>
.container {
  width: 100%;
  height: 100%;
}

.topSelect {
  width: 100%;
  padding: 0.266667rem;
}

#mountNode {
  width: 100%;
  height: 260px;
}
</style>